import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import LoginPage from "../pages/login/Login";
import MainLayout from "../pages/main layout/MainLayOut";
import Home from "../pages/home/Home";
import ContactPage from "../pages/conatct us/ContactPage";
import AboutPage from "../pages/about/AboutPage";
import AllCargo from "../pages/cargo/AllCargo";
import CargoDetail from "../pages/cargo detail/CargoDetail";
import RegisterCargo from "../pages/register cargo/RegisterCargo";
import Dashboard from "../pages/dashboard/Dashboard"
import DriverList from "../pages/dashboard/my cargo/component/DriverList";
import CargoLayout from "../pages/main layout/cargoLayout/CargoLayout";
import AdsPage from "../pages/rent/ads/Ads"
import AdsDetail from "../pages/rent/adsDetail/AdsDetail"
import RegisterAds from "../pages/rent/registerAds/RegisterAds";
import AdsDashboard from "../pages/rent/dashboard/Dashboard";
import CargoDetailDriver from "../pages/driver/cargo detail/CargoDetail";
import RegisterInfo from "../pages/driver/registerInfo/RegisterInfo";
import AdsLayout from "../pages/main layout/adsLayout/AdsLayout";
import DriverDashboard from "../pages/driver/dashboard/Dashboard";
import DriverCargo from "../pages/driver/cargos/AllCargo";
import DriverLayout from "../pages/main layout/driverLayout/DriverLayout";
function AppRoutes() {
  const token = useSelector((state) => state.login?.token);
  return (
    <BrowserRouter>
      <Routes>

           <Route path="/" element={<MainLayout />} >
              <Route path="/" element={<Home></Home>} />
              <Route path="/contact" element={<ContactPage></ContactPage>} />
              <Route path="/about" element={<AboutPage></AboutPage>} />
    
            </Route >

             {/* cargo layout */}
            <Route path="/cargo" element={<CargoLayout></CargoLayout>}>
              <Route path="/cargo" element={<AllCargo />} />
            </Route>

            <Route path="/driver" element={<DriverLayout/>}>
              <Route path="/driver/cargo" element={<DriverCargo></DriverCargo>} />
            </Route>

            <Route path="/ads" element={<AdsLayout></AdsLayout>}>
   
              <Route path="/ads" element={<AdsPage />} />
            
            </Route>

        {token && token !== undefined ? (
          <>
           

            {/* cargo layout */}
            <Route path="/cargo" element={<CargoLayout></CargoLayout>}>
              <Route path="/cargo/:id" element={<CargoDetail />} />
              <Route path="/cargo/dashboardCargo" element={<Dashboard />} />
              <Route path="/cargo" element={<AllCargo />} />
           
            </Route>

            <Route path="/driver" element={<DriverLayout/>}>
              <Route path="/driver/dashboard" element={<DriverDashboard></DriverDashboard>} />
              <Route path="/driver/cargo" element={<DriverCargo></DriverCargo>} />
              <Route path="/driver/cargo/:id" element={<CargoDetailDriver />} />
            </Route>

            <Route path="/ads" element={<AdsLayout></AdsLayout>}>
              <Route path="/ads/:id" element={<AdsDetail />} />
              <Route path="/ads" element={<AdsPage />} />
            
            </Route>

            <Route path="/ads/dashboard" element={<AdsDashboard />} />
            <Route path="/driver/registerinfo" element={<RegisterInfo />} />
            <Route path="/registerCargo" element={<RegisterCargo />} />
            <Route path="/registerAds" element={<RegisterAds />} />
          </>
        ) : (

          <>
            <Route path="/login" element={<LoginPage />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </>
        )}
      </Routes>
    </BrowserRouter>
  );
}

export default AppRoutes;